const isOfficeRoamingSettingsAvailable = (): boolean => {
  try {
    return !!(typeof Office !== "undefined" && Office.context && Office.context.roamingSettings);
  } catch {
    return false;
  }
};

export const saveToStorage = async (key: string, value: unknown): Promise<void> => {
  const serializedValue = JSON.stringify(value);

  localStorage.setItem(key, serializedValue);

  if (isOfficeRoamingSettingsAvailable()) {
    try {
      Office.context.roamingSettings.set(key, serializedValue);
      await new Promise<void>((resolve) => {
        Office.context.roamingSettings.saveAsync((asyncResult) => {
          if (asyncResult.status !== Office.AsyncResultStatus.Succeeded) {
            console.warn("roamingSettings save failed:", asyncResult.error);
          }
          resolve();
        });
      });
    } catch (error) {
      console.warn("Error saving to roamingSettings:", error);
    }
  }
};

export const getFromStorage = <T>(key: string): T | null => {
  try {
    const localValue = localStorage.getItem(key);
    if (localValue) {
      return JSON.parse(localValue) as T;
    }
  } catch (error) {
    console.warn("Error reading from localStorage:", error);
  }

  if (isOfficeRoamingSettingsAvailable()) {
    try {
      const roamingValue = Office.context.roamingSettings.get(key);
      if (roamingValue) {
        return JSON.parse(roamingValue) as T;
      }
    } catch (error) {
      console.warn("Error reading from roamingSettings:", error);
    }
  }

  return null;
};

export const removeFromStorage = async (key: string): Promise<void> => {
  localStorage.removeItem(key);

  if (isOfficeRoamingSettingsAvailable()) {
    try {
      Office.context.roamingSettings.remove(key);
      await new Promise<void>((resolve) => {
        Office.context.roamingSettings.saveAsync((asyncResult) => {
          if (asyncResult.status !== Office.AsyncResultStatus.Succeeded) {
            console.warn("roamingSettings remove failed:", asyncResult.error);
          }
          resolve();
        });
      });
    } catch (error) {
      console.warn("Error removing from roamingSettings:", error);
    }
  }
};
